<template>
  <div class="case_banner">
    <div>
      <img src="../../assets/case.jpg" />
      <div class="wenan">
        <div class="wen_title">相关案例</div>
        <div class="wen_content">
          以满足客户流程数字化管控+智慧物联场景建设需求为核心 <br />
          帮助制造企业实现供应敏捷化、制造柔性化、产品个性化、决策智能化
        </div>
      </div>
    </div>
  </div>
</template>
<script></script>
<style></style>